import { SchoolService, BaseService } from "@/services/school.service";

const RoomService = {
    getRooms () {
        return BaseService.getAll("rooms")
    },

    getSchoolRooms () {
        return SchoolService.getAll("rooms")
    },

    add(payload) {
    	return SchoolService.create("rooms", payload)
    },

    delete(object) {
        return SchoolService.delete("rooms", object.identifier, null)
    },
     
}

export { RoomService };
